import React from 'react'
import {
  CAlert,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormInput,
  CRow,
} from '@coreui/react-pro'
import { useEditWithdrawalGroup } from './hooks'
import { setWithdrawalGroup, submitEditWithdrawalGroup } from './model'
export const WithdrawalGroupEditDetail = () => {
  const { withdrawalGroup, loading, error } = useEditWithdrawalGroup()
  const handleChange = (event: {
    currentTarget: { name: any; type: string; checked?: any; value: any }
  }) => {
    const value =
      event.currentTarget.type === 'checkbox'
        ? event.currentTarget.checked
        : event.currentTarget.value

    setWithdrawalGroup({
      ...withdrawalGroup,
      [event.currentTarget.name]: value,
    })
  }

  if (loading) {
    return <div>Loading</div>
  }

  return (
    <div>
      <CCard className="mb-4">
        <CCardHeader className="d-sm-flex justify-content-between align-items-center">
          <strong>Edit payment group {withdrawalGroup.id}</strong>
        </CCardHeader>
        <CCardBody>
          <CCol xs={12} className="mb-2">
            {error.message.length > 0 && (
              <CAlert color="danger">Error code: {error.message}</CAlert>
            )}
          </CCol>
          <CForm>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormInput
                  type="text"
                  id="name"
                  name="name"
                  value={withdrawalGroup.name}
                  onChange={handleChange}
                  label="Name"
                />
              </CCol>
            </CRow>
            <CButton
              className="mb-3"
              disabled={loading}
              onClick={() => submitEditWithdrawalGroup(withdrawalGroup)}
            >
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              Save
            </CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </div>
  )
}
